/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

 export default {
   path: "/app/config/control-cambios",
   name: "CONTROL_CHANGES",
   component: () => import("@/app/views/ReadView.vue"),
   meta: {
     info: () => import("@/app/components/config/ChangeControlInfo"),
     header: {
       icono: "mdi-clipboard-text-outline",
       texto: "Control de cambios",
       textNew: "Control de cambios",
       textEdit: "Control de cambios",
     },
    //  requireAuth: true,
   },
 };
 